export enum EDocusignButton {
    MISSION_SUBSCRIBER_SIGN_BUTTON_ELEMENT_ID = "78a56b2b-275d-4781-b0b9-e1c00e55992f",
    MISSION_CO_SUBSCRIBER_SIGN_BUTTON_ELEMENT_ID = "20df1230-5e81-485e-8a80-8bdc5c2eabd0",
    MISSION_SUBSCRIBER_SPOUSE_SIGN_BUTTON_ELEMENT_ID = "3ae7bee9-6621-47e8-91c9-d154ad05987a",
    SUBSCRIPTION_SUBSCRIBER_SIGN_BUTTON_ELEMENT_ID = "2162a058-1f22-4bc2-bd51-dd6587c7d672",
    SUBSCRIPTION_CO_SUBSCRIBER_SIGN_BUTTON_ELEMENT_ID = "6357e0f5-6204-487e-8c27-6dd4bbebfede",
    SUBSCRIPTION_SUBSCRIBER_SPOUSE_SIGN_BUTTON_ELEMENT_ID = "43eb508f-2e56-4e82-bc07-735dadaac28f",
    SUBSCRIPTION_SUBSCRIBER_ADVISOR_SIGN_BUTTON_ELEMENT_ID = "a8bab2c3-19ac-4792-aa6a-bb975092e1be",
}